"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = valueAddedSubjectPriceIndirect;

var _priceFromMultiprice = _interopRequireDefault(require("../priceFromMultiprice"));

function valueAddedSubjectPriceIndirect(ctx, rule, subject, resultCtx) {
  var currency = ctx.currency;
  var _resultCtx$partial$in = resultCtx.partial.indirectSubjects,
      indirectSubjects = _resultCtx$partial$in === void 0 ? [] : _resultCtx$partial$in;
  var sum = indirectSubjects.reduce(function (s, is) {
    return s + (0, _priceFromMultiprice.default)({
      defaultValue: 0
    }, currency, is.listPrice || []) * (is.quantity || 0) * (is.numberOfRepeats || 1);
  }, 0);
  return sum;
}